module.exports = __webpack_public_path__ + "img/shangYeDJZ.933de141.png";